// extracted by mini-css-extract-plugin
module.exports = {"social__error":"social__error-DB_dNiQ","social__btn_label":"social__btn_label-3C0ddu7"};